export default "__VITE_ASSET__394b9cdb__"